import ElementPlus from "element-plus"; //全局引入
import "element-plus/dist/index.css";

const registerElementPlus = app => {
  app.use(ElementPlus);
};

export default registerElementPlus;
